import { render, staticRenderFns } from "./ClaimsTable.vue?vue&type=template&id=3bdcd606"
import script from "./ClaimsTable.vue?vue&type=script&lang=ts"
export * from "./ClaimsTable.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsTable.vue?vue&type=style&index=0&id=3bdcd606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports